import * as XLSX from 'xlsx';

const generateCurrencyExcel = (overallData) => {
  const formattedData = overallData.map((item, index) => ({
    ID: index + 1,
    'Country Name': item?.country_name || '',
    'Currency Name': item?.currency_name || '',
    Rate: item?.rate || 0,
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

  // Add optional title and header row 
  XLSX.utils.sheet_add_aoa(
    worksheet,
    [
      ['Currency Master Report'], // Title row
      [], // Spacer row
      ['ID', 'Country Name', 'Currency Name', 'Rate'], // Header row
    ],
    { origin: 'A1' },
  );

  // Add actual data starting from row 4
  XLSX.utils.sheet_add_json(worksheet, formattedData, {
    origin: 'A4',
    skipHeader: true, // Already added header above
  });

  // Merge title row (A1:D1)
  worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }];

  // Column widths for better readability
  worksheet['!cols'] = [
    { wch: 5 }, // ID
    { wch: 30 }, // Country Name
    { wch: 25 }, // Currency Name
    { wch: 15 }, // Rate
  ];

  // Create and export workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Currency Master');
  XLSX.writeFile(workbook, 'currency_master.csv');
};

export default generateCurrencyExcel;
